import { ArrowDropDown } from '@mui/icons-material';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import type React from 'react';
import { useState } from 'react';
import { StyledContextMenu } from 'src/components/menus/StyledContextMenu';
import type { ActionItem } from 'src/constants';
import styles from './TopPaginationActionsStyles';

interface BasePaginationActionsProps {
  actions: ActionItem[];
  onActionClick: (option: ActionItem) => void;
  disabled?: boolean;
}

const BasePaginationActions: React.FC<BasePaginationActionsProps> = ({ actions, onActionClick, disabled }) => {
  const classes = styles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleAction = (action: ActionItem): void => {
    onActionClick(action);
    handleClose();
  };

  return (
    <div>
      <Button
        disabled={disabled}
        classes={{ root: classes.actionsButton }}
        aria-controls="actions"
        aria-haspopup="true"
        onClick={handleClick}
        endIcon={<ArrowDropDown />}
      >
        <Typography className={classes.actionsText}>Actions</Typography>
      </Button>
      <StyledContextMenu
        actions={actions}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onAction={(action) => handleAction(action)}
        dangerLabels={['Delete', 'Delete Selected']}
        testIdPrefix="cyp-pagination-action"
      />
    </div>
  );
};

export default BasePaginationActions;
